/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import AmplifyTOTPSetup from "aws-amplify-react/lib/Auth/TOTPSetup";
import TOTPSetupComp from "aws-amplify-react/lib/Widget/TOTPSetupComp";
import { applyPostAuthState } from "auth/services";
import { AuthShell } from "./AuthFormShared";

const TOTPSetupBase: any = AmplifyTOTPSetup;

/** Wraps Amplify's TOTP setup widget in the login chrome. */
export class TOTPSetup extends TOTPSetupBase {
    checkContact(user: unknown) {
        applyPostAuthState(
            user,
            (state, data) => this.changeState(state, data),
            {
                setLoading: loading => this.setState({ loading }),
            },
        );
    }

    showComponent() {
        const { hide } = this.props;
        if (hide && hide.includes(TOTPSetup)) {
            return null;
        }

        return (
            <AuthShell title="Set up authenticator">
                <TOTPSetupComp {...this.props} onTOTPEvent={this.onTOTPEvent} />
            </AuthShell>
        );
    }
}

export default TOTPSetup;
